import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import 'app/entities/registration/registration.scss';
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {CaseType} from 'app/shared/model/enumerations/case-type.model';
import RegistrationButtons from './registration-buttons';

interface IMotherEmergencyTypeProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const MotherEmergencyType = (props: IMotherEmergencyTypeProps) => {
  const { patientCase} = props;

  const handleEmergencyTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setRegistrationData({
      patientCase: {
        ...patientCase,
        emergencyType: e.target.value as EmergencyType
      }
    });
  };

  // Filter emergency types based on patient case type
  const getFilteredEmergencyTypes = (): EmergencyType[] => {
    const types = Object.values(EmergencyType).filter(type => type !== EmergencyType.NEONATAL);

    // If patient case type is BOTH, only show POSTPARTUM
    if (patientCase && patientCase.type === CaseType.BOTH) {
      return types.filter(type => type === EmergencyType.POSTPARTUM);
    }

    return types;
  };

  // Check if the current emergency type is valid for the current case type
  const isEmergencyTypeValid = (): boolean => {
    const validTypes = getFilteredEmergencyTypes();
    return patientCase?.emergencyType ? validTypes.includes(patientCase?.emergencyType) : false;
  };

  useEffect(() => {
    // Check if currently selected emergency type is valid for the case type
    if (patientCase?.emergencyType) {
      if (!isEmergencyTypeValid()) {
        // If current emergency type is not valid for the case type, unselect it
        props.setRegistrationData({
          patientCase: {
            ...patientCase,
            emergencyType: null
          }
        });
      }
    }
  }, [patientCase]); // Re-run this effect when patientCase changes

  return (
    <div>
      <h2 className="mb-4">Is the mother...</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <AvRadioGroup name="radio-button-group" required value={patientCase?.emergencyType} errorMessage="Please select an option">
          <Row>
            {getFilteredEmergencyTypes().map((type, index) => (
              <Col md="4" key={index}>
                <Label className="radio-button-label">
                  <AvRadio
                    type="radio"
                    name="emergencyType"
                    value={type}
                    onChange={handleEmergencyTypeChange}
                    className="radio-button-input"
                  />
                  {type}
                </Label>
              </Col>
            ))}
          </Row>
        </AvRadioGroup>
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  patientCase: state.registration.entity.patientCase,
});

const mapDispatchToProps = {
  setRegistrationData,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MotherEmergencyType);
